import { FC } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { LoadMoreButton } from '../../../../../components/load-more-button/index';
import {
  BrowserNodeActions,
  SpaceBrowserFile,
  SpaceBrowserFolder,
  SpaceBrowserPagination,
} from '../../../types/data-room.types';
import { SpaceFolderIcon } from '../../components/space-folder-icon';
import { BrowserFileIcon } from '../browser-file-icon';
import { MobileNodeRow } from './mobile-node-row';

export type MobileNodeListProps = {
  actions: BrowserNodeActions;
  files: SpaceBrowserFile[];
  folders: SpaceBrowserFolder[];
  onOpenFolder: (folderId: string) => void;
  pagination: SpaceBrowserPagination;
};

export const MobileNodeList: FC<MobileNodeListProps> = ({
  actions: { onDownloadFile, onDownloadFolder, onOpenFile },
  files,
  folders,
  onOpenFolder,
  pagination,
}) => (
  <>
    <div className="overflow-hidden rounded-lg border border-gray-100 bg-white">
      {folders.map(({ id, isShared, itemCount, name }) => (
        <MobileNodeRow
          icon={<SpaceFolderIcon className="size-8" isShared={isShared} size={32} />}
          key={id}
          name={name}
          onDownload={onDownloadFolder && (() => onDownloadFolder(id))}
          onOpen={() => onOpenFolder(id)}
          subtitle={
            itemCount !== null && (
              <AppFormattedMessage id="ITEMS_COUNT" values={{ count: itemCount }} />
            )
          }
        />
      ))}
      {files.map((file) => (
        <MobileNodeRow
          icon={<BrowserFileIcon contentType={file.contentType} />}
          key={file.id}
          name={file.name}
          onDownload={onDownloadFile && (() => onDownloadFile(file.id))}
          onOpen={onOpenFile ? () => onOpenFile(file.id, file.name) : undefined}
        />
      ))}
    </div>
    {(pagination.nextPageSize > 0 || pagination.canShowLess) && (
      // Centred, as the strip under the desktop table is: the pill is only as wide as its label.
      <div className="flex justify-center">
        <LoadMoreButton
          count={pagination.nextPageSize}
          isLoading={pagination.isLoadingMore || pagination.isReloading}
          onLoadMore={pagination.loadMore}
          onShowLess={pagination.showLess}
          showLess={pagination.canShowLess}
        />
      </div>
    )}
  </>
);
